import React, { FunctionComponent, useContext } from 'react'
import styled from '@emotion/styled'
import { Routes, Route } from 'react-router-dom'
import { RouteConfig } from 'view/routes/index'
import * as constants from 'view/styles/constants'
import { ActivityIndicator } from 'view/shared/activityMonitor'
import { HomeTile } from './HomeTile'
import { UserSettings } from './userSettings/UserSettings'
import { EnvironmentContext } from 'view/shared/environment'
import { LeftNavigationToggle } from 'view/shared/leftNavigation'
import { SuspensionIndicator } from 'view/shared/suspensionIndicator'

const HeaderStyled = styled.header`
  flex: 0 0 auto;
  height: 44px;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  background-color: ${constants.CORE_PRIMARY};
  position: relative;
  z-index: 1;
  padding: 0 0 0 10px;
  & > * {
    margin-right: 10px;
  }
`

const GradientOverlay = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 20px;
  z-index: -1;
  background-image: linear-gradient(to top, rgba(0, 0, 0, 0.03) 0%, rgba(255, 255, 255, 0) 100%);
`

const ToolbarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 1 1 auto;
`

const NavigationBarStyled = styled.nav`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;
`

interface HeaderProps {
  routes: RouteConfig[]
}

export const Header: FunctionComponent<HeaderProps> = ({ routes }) => {
  const environment = useContext(EnvironmentContext)

  return (
    <HeaderStyled>
      <NavigationBarStyled role="navigation">
        <HomeTile showLogo={true}>
          <LeftNavigationToggle />
        </HomeTile>
      </NavigationBarStyled>
      <ToolbarContainer>
        {!environment.isAdmin && <SuspensionIndicator />}
        <Routes>
          {routes
            .filter(r => !!r.toolbar)
            .map(route => (
              <Route key={route.url} path={route.url} element={route.toolbar} />
            ))}
        </Routes>
      </ToolbarContainer>
      {!environment.isAdmin && <UserSettings />}
      <ActivityIndicator />
      <GradientOverlay />
    </HeaderStyled>
  )
}
